import React from 'react';
import Dashboard from './Dashboard';
import { useExportHandler } from './utils/exportHandler';
import MockupHub from './components/mockups/MockupHub';
import OverviewTabMockup from './components/mockups/OverviewTabMockup';
import ThisMonthTabMockup from './components/mockups/ThisMonthTabMockup';
import ThisWeekTabMockup from './components/mockups/ThisWeekTabMockup';
import LastMonthTabMockup from './components/mockups/LastMonthTabMockup';
import LastWeekTabMockup from './components/mockups/LastWeekTabMockup';
import HistoricalTabMockup from './components/mockups/HistoricalTabMockup';

/**
 * App Component
 *
 * Supports mockup viewing via URL parameter:
 * - Normal: http://localhost:3001/
 * - MOCKUP HUB: http://localhost:3001/?mockup=hub  <-- USE THIS!
 * - Overview Mockup: http://localhost:3001/?mockup=overview
 * - ThisMonth Mockup: http://localhost:3001/?mockup=thismonth
 * - LastMonth Mockup: http://localhost:3001/?mockup=lastmonth
 * - ThisWeek Mockup: http://localhost:3001/?mockup=thisweek
 * - LastWeek Mockup: http://localhost:3001/?mockup=lastweek
 * - Historical Mockup: http://localhost:3001/?mockup=historical
 *   - With subtab: ?mockup=historical&subtab=rep-vs-rep
 *   - With subtab: ?mockup=historical&subtab=single-rep
 *   - With subtab: ?mockup=historical&subtab=team-snapshot
 *
 * This allows viewing proposed UX/UI enhancements before implementing.
 */
function App() {
  // Enable export handler for shell screenshot requests
  useExportHandler();
  // Check for mockup URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const mockup = urlParams.get('mockup');

  // Render mockup if requested
  if (mockup === 'hub') {
    return <MockupHub />;
  }

  if (mockup === 'overview') {
    return <OverviewTabMockup />;
  }

  if (mockup === 'thismonth') {
    return <ThisMonthTabMockup />;
  }

  if (mockup === 'lastmonth') {
    return <LastMonthTabMockup />;
  }

  if (mockup === 'thisweek') {
    return <ThisWeekTabMockup />;
  }

  if (mockup === 'lastweek') {
    return <LastWeekTabMockup />;
  }

  if (mockup === 'historical') {
    return <HistoricalTabMockup />;
  }

  // Default: render main dashboard
  return <Dashboard />;
}

export default App;
